import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import Style from '../style/dailyChallenges.module.scss'
import StartIcon from '../../../../assets/svg/StartIcon';
import PlayButton from '../../../../assets/svg/PlayButton';
import PersionIcon from '../../../../assets/svg/PersionIcon';
import HourGlassClock from '../../../../assets/svg/HourGlassClock';
import BackArrow from '../../../../assets/svg/BackArrow';
import QuizWallicon from '../../../../assets/svg/QuizWallicon';
import { getAllChallenges } from "../../../../redux/screen/getChallenges";
import { useNavigate } from 'react-router-dom';
import BottomBar from '../component/BottomBar';

function DailyChallenges(params) {
  window.scrollTo(0, 0);

  const dispatch = useDispatch()

  const challengeDetails = useSelector(state => state.getAllChallenges)

  const { data: challengeData, loading: missionDetailLoading, status, message } = challengeDetails
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllChallenges())
  }, [dispatch])
  return (
    <>
      <div className={Style.box_container}>
        <div className={Style.challenge_box_container_top}>
          <div onClick={() => navigate("/home-challenge")}>
            <BackArrow />
          </div>
          <QuizWallicon width={143} height={31} />
        </div>

        <div className={Style.challenge_box_container}>
          <h3 className={Style.ch_text1}>Daily Challenges</h3>
          <p className={Style.ch_text2}>Choose any of your favourite genre and get started.</p>
          {
            challengeData.length > 0 ? (
              challengeData.map((ele) => (
                <div
                  className={Style.challenge_box}
                  key={ele?._id}
                  onClick={() => navigate(`/start-quiz/${ele._id}`)}
                >
                  <div className={Style.image_box}>
                    <img src={ele?.image} className={Style.background_image} alt={ele?.challenge_name} />
                  </div>
                  <div className={Style.bottom_box}>
                    <p className={Style.challenge_text1}>{ele?.challenge_name}</p>
                    <div className={Style.challenge_box2}>
                      <p className={Style.challenge_text2}>{ele?.cat_id?.cat_name} |&nbsp;</p>
                      <p className={Style.challenge_text2}>{ele?.attempt} attempts</p>
                    </div>
                    <div className={Style.challenge_box2}>
                      <p className={Style.challenge_text3}>
                        <StartIcon width={9} height={9} />
                        <span>{ele?.total_ques || 10} Q&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      </p>
                      <p className={Style.challenge_text3}>
                        <HourGlassClock width={9} height={9} />
                        <span>{ele?.duration || 4} mins &nbsp;&nbsp;|&nbsp;&nbsp;</span>
                      </p>
                      <p className={Style.challenge_text3}>
                        <PersionIcon width={9} height={9} />
                        {ele?.total_attempted || 0}
                      </p>
                    </div>
                    <div className={Style.challenge_box3}>
                      <p className={Style.challenge_text4}>Earn {ele?.reward} Coins</p>
                      <div className={Style.play_button}>
                        <PlayButton width={24} height={10} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className={Style.noChallengeBox}>
                <p className={Style.noChallengeText}>No challenges available right now. 🚀</p>
              </div>
            )
          }


        </div>
        <BottomBar />
      </div>
    </>
  )
}

export default DailyChallenges;